const AccountUrls = {
  getAccessToken: "api/Account/GetAccessToken",
  getLoginSettings: "/api/MarketPlace/GetLoginSettings",
  requestAuthCode: "/api/Passenger/RequestAuthCode",
  confirmAuthCode: "/api/Passenger/ConfirmAuthCode",
  changePassword: "api/Account/ChangePassword",
  requestPasswordResetToken: "api/Account/RequestPasswordResetToken",
  resetPassword: "api/Account/ResetPassword",
  resetPasswordLink: "/api/Account/ResetPasswordLink",
  signOut: "/api/Account/SignOut",
  getCaptcha: "/api/Account/GetCaptcha",
};
export default AccountUrls;
